import React, { FunctionComponent } from "react";
import { useTheme } from "styled-components";

interface ArrowDiagonalProps {
  className?: string;
}

const ArrowDiagonal: FunctionComponent<ArrowDiagonalProps> = ({
  className,
}) => {
  const theme = useTheme();
  return (
    <svg
      className={className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
    >
      <path
        opacity="0.5"
        d="M1 8L8 1M8 1H2.75M8 1V6.25"
        stroke={theme.colors.textGrey}
      />
    </svg>
  );
};

export default ArrowDiagonal;
